/**
 * Barcode - 条形码生成组件
 * 用于GDS追溯页面展示商品条形码
 */

import React, { useEffect, useRef } from 'react';
import './Barcode.css';

function Barcode({ value, width = 200, height = 80, displayValue = true, format = 'CODE128' }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!value || !canvasRef.current) return;

    // 简化版条形码生成（实际项目建议使用 JsBarcode 库）
    generateBarcode(canvasRef.current, value, { width, height, displayValue, format });
  }, [value, width, height, displayValue, format]);

  // 简化的条形码生成逻辑
  const generateBarcode = (canvas, code, options) => {
    const ctx = canvas.getContext('2d');
    const { width, height, displayValue } = options;
    
    // 设置canvas尺寸
    canvas.width = width;
    canvas.height = height;
    
    // 清空画布
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, width, height);
    
    // 绘制条形码（简化版 - 垂直条纹）
    const barWidth = width / (code.length * 2);
    const barHeight = displayValue ? height - 25 : height - 10;
    
    ctx.fillStyle = '#000000';
    
    for (let i = 0; i < code.length; i++) {
      const digit = parseInt(code[i]) || 0;
      const x = i * barWidth * 2 + 10;
      
      // 根据数字决定条纹宽度（模拟条形码）
      if (digit % 2 === 0) {
        ctx.fillRect(x, 5, barWidth * 1.5, barHeight);
      } else {
        ctx.fillRect(x, 5, barWidth, barHeight);
      }
    }
    
    // 显示数字
    if (displayValue) {
      ctx.fillStyle = '#000000';
      ctx.font = '14px monospace';
      ctx.textAlign = 'center';
      ctx.fillText(code, width / 2, height - 5);
    }
  };

  return (
    <div className="barcode-container">
      <canvas ref={canvasRef} className="barcode-canvas" />
    </div>
  );
}

export default Barcode;

